// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"dac90578","355":"2ff276ca","455":"41c0a3cd","977":"ff9327bc"}[chunkId] + ".chunk.js";
};